export const blockIconsHomeFloorLampNew = (
	<span className='material-symbols-outlined'>floor_lamp</span>
);
